import { Component, OnInit } from '@angular/core';
import { FormGroup,Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
  basicInfoForm = new FormGroup({
    firstName: new FormControl('',Validators.required),
    middleName: new FormControl(''),
    lastName: new FormControl('', Validators.required),
  });
  secondaryDetailsForm = new FormGroup({
    email: new FormControl('',[Validators.required,Validators.email]),
    password: new FormControl('', [Validators.required, Validators.minLength(8),Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?!.*(.).*\1.*\1.*\1.*\1)(?=.{8,})/)]),
    confirmPassword: new FormControl('', [Validators.required, Validators.minLength(8),Validators.pattern(/^(?=\D*\d)(?=[^a-z]*[a-z])(?=[^A-Z]*[A-Z]).{8,30}$/)])
  });


  showPersonForm = true;
  showSecondaryForm = false;
  errorMessage = '';
  signupSuccess = true;
  // extraValidation="";
  constructor(private router:Router,
              private userService:UserService) { }

  ngOnInit(): void {
  }
  onBasicInfoSubmit() : void {
    if(this.basicInfoForm.valid){
      this.showPersonForm = false;
      this.showSecondaryForm = true;
    }
  }
  onSecondaryFormSubmit() : void{
    if(this.secondaryDetailsForm.valid){
        const {password, email} = this.secondaryDetailsForm.value;
        const payload = {
          ...this.basicInfoForm.value,
          profileName: null,
          password,
          email,
        }
        //this.onExtraValidation(password);
        this.userService.signup(payload).subscribe(
          (res:any) => {
            if(res.responseStatus === 'Success'){
              this.errorMessage = '';
              this.router.navigate(['/user/login']);
            }else if(res.responseStatus === 'Failed'){
              this.errorMessage = res.responseMessage;
            }
          },
          err => {
            console.log(err);
          }
        )
    }
  }

  // onExtraValidation(passwordValue:any){
  //   if(passwordValue =="world" || passwordValue=="Universe"){

  //  }
  // }

}
